<template>
  <div class="container">
    <div class="image-row">
      <!-- <div class="img-container"> -->
        <img src="../assets/forUsBanner2.png" alt="" class="img">
        
      <!-- </div> -->
    </div>
    <div class="button-img">
          <div class="btn btn1" :class="{currentTab:currentTab==1}" @click="changeTab(1)">公司介绍</div>
          <div class="btn" :class="{currentTab:currentTab==2}" @click="changeTab(2)">联系我们</div>
        </div>
    <Company v-show="currentTab==1"></Company>
    <Contact v-show="currentTab==2"></Contact>
  </div>
</template>

<script>
  import Company from './company'
  import Contact from './contact'
  export default {
    name: 'for-us',
    components:{
      Company,
      Contact
    },
    data () {
      return {
        currentTab:1,  // 公司介绍
        img: require('../assets/forUsBanner.png')
      }
    },
    methods:{
      changeTab(index){
        this.currentTab=index
      }
    }
  }
</script>

<style scoped>
.container{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.image-row{
  width: 100%;
  /* height: 300px; */
  /* background:linear-gradient(0deg,rgba(43,196,253,1),rgba(29,114,221,1)); */
  display: flex;
  justify-content: center;
}
.img{
  width: 100%;
}
.img-container{
  height: 300px;
  width: 63.54%;
  margin: 0 auto;
}
.img-container .img{
  width: 100%;
  height: 100%;
}
.button-img{
  position: absolute;
  top:35%;
  background-image: url('../assets/botton-wrap.png');
  width: 125px;
  height: 132px;
  align-self: flex-start;
  margin-left: 18.22%;
}
.btn{
  height: 48px;
  line-height: 48px;
  font-size:18px;
  font-weight:400;
  color:rgba(255,255,255,1);
  text-align: center;
  cursor: pointer;
}
.btn1{
  margin-top: 5px;
}
.currentTab{
  background:#2166C2;
  font-weight:bold;
  color:rgba(255,255,255,1);
}
</style>



// WEBPACK FOOTER //
// src/components/for-us2.vue